import { render, staticRenderFns } from "./RulesHistoryTab.vue?vue&type=template&id=a3e26474"
import script from "./RulesHistoryTab.vue?vue&type=script&lang=js"
export * from "./RulesHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports